
(function() {
	$.mobile.linkBindingEnabled = false;

	/**
	 * Estetään kontekstivalikon käyttö, esimerkiksi kokoruudun tilasta poistumisen estämiseksi
	 */
	try {
		document.oncontextmenu = function() { return false; };
	} catch (error) { console.error( error ); }

	/**
	 * Otetaan haltuun käsky mahdollisesta kehitystyötilasta
	 */
	try {
		if (("&"+window.location.search.substr(1)).indexOf("&DEV=") != -1) window.DEV = true;
	} catch (error) { }


	angular.module( 'showcaseBase', [ 'ApiHandler', 'ui-notification', 'ipCookie', 'ngAnimate', 'ngSanitize', 'gettext' ])

	.constant( 'SHOWCASE_ASSETS_URL', window.SHOWCASE_ASSETS_URL )

	.constant( 'SHOWCASE_CLIENT', window.SHOWCASE_CLIENT )

	.value( 'CUSTOM_SHOWCASE_CONFIGS', window.CUSTOM_SHOWCASE_CONFIGS )

	.value( 'SHOWCASE_CONFIG', window.SHOWCASE_CONFIG )

	.config([ '$controllerProvider', '$sanitizeProvider', function( $controllerProvider, $sanitizeProvider ) {

		window.controllerProvider = $controllerProvider;

		$sanitizeProvider.addValidAttrs([ 'style' ]);

	}])

	.run([ "$rootScope", "gettextCatalog", function( $rootScope, gettextCatalog ) {

		gettextCatalog.currentLanguage = "fi_FI";

		$rootScope.SHOWCASE_ASSETS_URL = window.SHOWCASE_ASSETS_URL;
		
		$rootScope.DEV = !!window.DEV;

		if (window.DEV) {
			([
				[ "$stateChangeStart" ],
				[ "$stateChangeSuccess" ],
				[ "$stateNotFound" ],
				[ "$stateChangeError" ],

				[ "currentStateChanged" ],
				[ "help.open" ],
				[ "help.close" ],
				[ "zoom.open" ],
				[ "zoom.close" ],
				[ "wall_preview.open" ],
				[ "wall_preview.close" ]
			]).forEach(function( v ) {
				var str = "$("+ v[0] +")";
				if (v[1]) str += " :: " + v[1] + " =";

				$rootScope.$on( v[0], function( event ) {
					console.debug.apply( console, [ str ].concat( Array.prototype.slice.call( arguments, 1 )) );
				});
			});
		}

		/** Napataan tieto esityksen tilan vaihtumisesta ja välitetään tieto analytiikalle */
		$rootScope.$on( "currentStateChanged", function( event, to, from ) {
			try { gtag( 'event', 'showcase_state_change', { value: to }) } catch (e) {}
		});
	}]);

})();

angular.module( 'showcaseModules', [ 'showcaseBase' ]);

angular.module( 'showcase', [ 'showcaseBase', 'showcaseModules' ]);

angular.module( 'showcase' )
.run([   '$ApiHandler','$q','$rootScope','$sce','gettextCatalog','$templateCache',"$http","$interpolate",'settingsService','showcaseEngineModifier',
function( $ApiHandler,  $q,  $rootScope,  $sce,  gettextCatalog,  $templateCache,  $http,  $interpolate,  settingsService,  showcaseEngineModifier ) {

	var gettext = function( key ){ return gettextCatalog.getString( key ); };

	$rootScope.errors = [];
	$rootScope.properties_list = {};

	$rootScope.runningtimeout = null;

	$rootScope.timeoutPauseable = true;
	$rootScope.toggleAnimationPause = function() {
		if (!$rootScope.runningtimeout) return;

		if ($rootScope.runningtimeout.$$paused_ms == null) {
			$rootScope.runningtimeout.pause();

			console.log( "Animation toggle :: Paused at", $rootScope.runningtimeout.play_ms );
		} else {

			$rootScope.runningtimeout.unpause();

			console.log( "Animation toggle :: Continued from", $rootScope.runningtimeout.play_ms );
		}
	};

	$rootScope.audioMuted = false;
	$rootScope.audioMuteable = false;
	$rootScope.toggleAudioMute = function() {
		$rootScope.audioMuted = !$rootScope.audioMuted;
		$("audio").each(function(){ this.muted = $rootScope.audioMuted; });
	};
	$rootScope.$watch(function(){
		$rootScope.audioMuteable = document.getElementsByTagName("audio").length > 0;
	});

	var settings = $rootScope.settings = null;

	$rootScope.ready = settingsService.init().then(function( _settings ) {

		$rootScope.settings = settings = _settings;

		$rootScope.client_uid = settings.global.client_uid;

		$templateCache.put( 'templates.start.content.html', '' );

		try {
			if (settings.views.start.start_content) {
				$templateCache.put( 'templates.start.content.html', settings.views.start.start_content );
			}
		} catch (error) {
			console.error( error );
		}

		try {
			if (settings.global.language) {

				if (gettextCatalog.strings[ settings.global.language ]) {

					gettextCatalog.currentLanguage = settings.global.language
				} else {
					console.warn( "Invalid argument global.language:", settings.global.language, "Not found from translations" );
				}
			}
		} catch (error) {
			console.error( error );
		}
	
		try {
			if (settings.views.show.timeout_pauseable == false) {
				$rootScope.timeoutPauseable = false;
			}
		} catch (error) {
			console.error( error );
		}

	}).then(function() {

		return $ApiHandler.get( "/oeuvres/properties", {
			'filters': 'onlydata,onlyattrs'
		}).then(function( response ) {

			$rootScope.properties_list.methods = response.data;

		});

	}).then(function() {

		if (settings.global.client_oeuvre_list_uid != null && settings.global.client_oeuvre_list_uid != '9600000000000000') {
			// Showcaseen on liitetty teostlista.
			// Noudetaan teoslistan sisältö ja parsitaan showcasen teokset sen mukaiseksi sekä otetaan mahdolliset muut tiedot käyttöön
			
			return $ApiHandler.get("/clients/" + $rootScope.client_uid +"/lists/oeuvres/" + settings.global.client_oeuvre_list_uid, {
				'filters':'onlydata,onlyattrs,asarray',
				'with': 'oeuvre,client_artist,images'
			}).then(function( response ) {

				return response.data[0];
			
			}).then(function( oeuvre_list ) {

				if (!oeuvre_list) return; // Listaa ei löytynyt! 

				try {
					if (!angular.isString( settings.global.display_name )) {
						settings.global.display_name = oeuvre_list.title;
					}
				} catch (error) {
					console.error( error );
				}

				/****
				 * Valmistautudutaan jo aikaan, kun showcasen kohteet irrotetaan teoslistasta.
				 * oeuvre_list'n ollessa läsnä, oletetaan kaikien kohteiden (settings.oeuvre_settings) 
				 * olevan tauluja, joten poistetaan ne, joita ei oeuvre_list'ssa ole.
				 */
				for (var id in settings.oeuvre_settings) {

					var found = false;

					for (var i in oeuvre_list.with.oeuvres) {
						if (oeuvre_list.with.oeuvres[i].uid == id) found = true;
					}

					if (!found) delete settings.oeuvre_settings[ id ];
				}

				return oeuvre_list;
			});

		} else {
			// Ei asetettu showcaseen linkitettyä listaa! Halutaan siis kaikkien settings.oeuvre_settings'ssa olevien kohteiden olevan käytössä.
			// Luodaan dummy-lista asetuksissa asetettujen teosten pohjalta.

			var client_oeuvre_uids = [];

			for (var i in settings.oeuvre_settings) {

				var uid = settings.oeuvre_settings[i].uid || i;

				if (uid.substr( 0, 2 ) == "92") client_oeuvre_uids.push( uid );
			}

			return $ApiHandler.get( "/clients/oeuvres", {
				clients_oeuvres_uids : client_oeuvre_uids.join(","),
				filters              : "onlydata,onlyattrs",
				with                 : "oeuvres,images"
			}).then(function( response ) {

				return {
					with: {
						oeuvres: response.data
					}
				};

			});
		}

	}).then(function( oeuvre_list ) {

		//let's build some variables in to the oeuvres so we do not need to iterate through them in the controller
		var oeuvres = new Array();
		var slides = oeuvres;

		var custom_showcase_configs_oeuvre_settings = window.CUSTOM_SHOWCASE_CONFIGS && window.CUSTOM_SHOWCASE_CONFIGS.oeuvre_settings || {};

		var showcase_total_duration_ms = 0;

		var oeuvre_list_oeuvres = oeuvre_list && oeuvre_list.with.oeuvres || {};
			
		for (var i in oeuvre_list_oeuvres) {
			var item = oeuvre_list.with.oeuvres[i];

			var isettings = $rootScope.settings.oeuvre_settings[item.uid] = $rootScope.settings.oeuvre_settings[item.uid] || {};
			if (isettings.ignore) continue;

			item.$settings = isettings;
			isettings.$item = item;

			item.priority          = isettings.priority;
			item.unique_play_sound = isettings.sound || false;
			item.show_details      = false;
			item.methods_string    = "";

			if (item.with && item.with.oeuvre) {
				item.methods_string = (item.with.oeuvre.methods_uids || []).map(function(uid){
					return gettextCatalog.getString( "oeuvre property "+uid );
				}).join(', ');
			}
			
			if (item.unique_play_sound && $rootScope.DEV) {
				item.unique_play_sound += (item.unique_play_sound.indexOf( "?" ) == -1 ? "?" : "&") + "_=" + Math.random();
			}

			for (var key in custom_showcase_configs_oeuvre_settings[ item.uid ]) {
				isettings[ '$$' + key ] = custom_showcase_configs_oeuvre_settings[ item.uid ][ key ];
			}

			if (typeof isettings.timeouttimems == "undefined" && typeof $rootScope.settings.views.show.timeouttimems != "undefined") {
				isettings.timeouttimems = $rootScope.settings.views.show.timeouttimems;
			}

			if (isettings.timeouttimems) {
				var val = parseInt( isettings.timeouttimems );

				if (isFinite(val) && !isNaN(val)) isettings.timeouttimems = val;

				showcase_total_duration_ms += isettings.timeouttimems;
			}

/*			item.$img_thumb = new Image();
			if (isettings.img_filename) {
				item.$img_thumb.src = window.SHOWCASE_ASSETS_URL + isettings.img_filename;
			} else {
				item.$img_thumb.src = "/i/"+ oeuvre.with.oeuvre.img_uid + "?size=normal";
			}*/

			// Rakennetan teoksen datat valmiiksi details-sivua varten
			isettings.details = isettings.details || {};
			if (!Array.isArray( isettings.details.rows )) {
				if (Array.isArray( $rootScope.settings.views.show.detailrows )) {
					isettings.details.rows = $rootScope.settings.views.show.detailrows;
				} else {
					isettings.details.rows = [ "oeuvre_title", "artist_name", "oeuvre_completed", "oeuvre_print_info", "oeuvre_methods_str", "oeuvre_size" ];
				}
			}

			isettings.$detailrows = isettings.details.rows.concat( isettings.detailrows || [] ).map(function( row ) {

				// [ .., "..", .. ]
				if (typeof row == "string") row = buildDetailRow( row, item );

				// [ .., { .. }, .. ], [ .., [ .. ], ..]
				if (typeof row == "object") {
					if (row.key) {
						nrow = buildDetailRow( row.key, item );
						if (row.label) nrow[0] = row.label;
						if (row.value) nrow[1] = row.value;
						row = nrow;
					}
				}

				return row;
			})
			.filter(function( row ) {

				if (row == null) return;
				if (!Array.isArray( row ) || row.length != 2) return console.warn( "Weird content in oeuvre_settings.$detailrows", row, "Should be array length of 2" );

				return true;
			})
			.map(function( row ) {

				var key = row[0], value = row[1];

				try {

					if (angular.isString( value ) && value.indexOf( "{{" ) != -1) {
						value = $interpolate( value )({ isettings: isettings });
					}

				} catch (error) {
					console.error( error );
				}

				try {

					if (angular.isString( value )) {
						value = value.replace( /\n/g, "<br>" );

						if (value.match( /<.+?>/ )) {
							value = $sce.trustAsHtml( value );
						}
					}

				} catch (error) {
					console.error( error );
				}

				return [ key, value ];
			});

			oeuvres.push( item );
		}


		slides = oeuvres = oeuvres.sort(function( a, b ) {
			return (a.priority == null ? Infinity : a.priority) - (b.priority == null ? Infinity : b.priority);
		});


		if (isNaN( showcase_total_duration_ms ) || !isFinite( showcase_total_duration_ms )) {
			console.error( "showcase_total_duration_ms" , showcase_total_duration_ms, "is NaN or not finite!" );
			debugger;
		}


		// TODO: Ketjuta promise oikein!!
		
		return showcaseEngineModifier.run( 'run_slidesInitializationChain_slidesOrderd()', { slides: slides, showcase_total_duration_ms }).then(function() {

			oeuvres.forEach(function( item ) {

				var isettings = $rootScope.settings.oeuvre_settings[item.uid];

				if (typeof isettings.$$universal_slide_loop_start_time != "undefined") {
					
					var val = isettings.$$universal_slide_loop_start_time;

					if (!angular.isNumber( val )) {
						val = isettings.$$universal_slide_loop_start_time = parseInt( val )
					}

					if (isFinite(val) && !isNaN( val )) {
						isettings.$$fetch_universal_slide_loop_start_time = (function(){
							var isettings = this;
							var item = this.$item;

							return $http.get( location.pathname + "?item=" + item.uid + "&universal_slide_loop=start_time&done=true" ).then(function( response ){
								var universal_slide_loop_start_time = parseInt( response.data.universal_slide_loop_start_time );
								var dtime = universal_slide_loop_start_time - isettings.$$universal_slide_loop_start_time;

								isettings.$$universal_slide_loop_start_time__updated_at = response.data.updated_at;
								if (Math.abs( dtime ) > 200) {
									isettings.$$universal_slide_loop_start_time = universal_slide_loop_start_time;
									return true;
								}
							});
						}).bind( isettings );

						isettings.$$get_ms_from_global_start_time = (function() {
							return (SERVER_LOAD_TIME - this.$$universal_slide_loop_start_time) + (Date.now() - BROWSER_LOAD_TIME);
						}).bind( isettings );

						if (angular.isNumber(isettings.timeouttimems) && isFinite(isettings.timeouttimems) && !isNaN(isettings.timeouttimems)) {
							isettings.$$get_ms_in_global_loop = (function() {
								//console.count( "isettings.$$get_ms_in_global_loop(" + this.$item.uid + ")" );
								return ((SERVER_LOAD_TIME - this.$$universal_slide_loop_start_time) + (Date.now() - BROWSER_LOAD_TIME)) % (this.timeouttimems);
							}).bind( isettings );
						}
					} else {
						console.warn( "Invalid parameter isettings.$$universal_slide_loop_start_time", isettings.$$universal_slide_loop_start_time );
						delete isettings.$$universal_slide_loop_start_time;
					}
				}
			});

			/****
			 * Valmistautudutaan jo aikaan, kun showcasen kohteet irrotetaan teoslistasta.
			 * oeuvre_list'n ollessa läsnä, oletetaan kaikien kohteiden (settings.oeuvre_settings) 
			 * olevan tauluja, joten poistetaan ne, joita ei oeuvre_list'ssa ole.
			 */
			/*if (oeuvre_list) {
				for (var id in $rootScope.settings.oeuvre_settings) {
					var found = false;
					for (var i in oeuvre_list.with.oeuvres) {
						if (oeuvre_list.with.oeuvres[i].uid == id) found = true;
					}
					if (!found) delete $rootScope.settings.oeuvre_settings[ id ];
				}
			}*/

			oeuvres.forEach(function( item ){
				if (item.unique_play_sound) try {
					var href = window.SHOWCASE_ASSETS_URL + item.unique_play_sound;
					var head_link = document.querySelector( 'head > link[href="' + href + '"]');
					if (!head_link) {
						head_link = document.createElement( "link" );
						head_link.rel = "preconnect";
						head_link.href = href;
						document.head.appendChild( head_link );
					}
				} catch( e ) { console.error(e); }
			});

			return showcaseEngineModifier.run( 'run_slidesInitializationChain_slidesReady()', { slides: slides });

		}).then(function() {

			return slides;

		});

		function buildDetailRow( key, oeuvre ){
			try {
				switch( key ) {
					case "oeuvre_title":
						return [ gettext('Title of the oeuvre'),                oeuvre.with.oeuvre.title ];
					case "artist_name":
						return [ gettext('The artist of the oeuvre'),           oeuvre.with.client_artist.name ];
					case "oeuvre_completed":
						return [ gettext('Time of completion or release'),      oeuvre.with.oeuvre.completed ];
					case "oeuvre_print_info":
						return [ gettext('About print numbering'),              oeuvre.with.oeuvre.print_number&&oeuvre.with.oeuvre.print_count ? (oeuvre.with.oeuvre.print_number + " / " + oeuvre.with.oeuvre.print_count) : "" ];
					case "oeuvre_methods_str":
						return [ gettext('Oeuvre methods'),                     oeuvre.methods_string ];
					case "oeuvre_size":
						var str  = oeuvre.with.oeuvre.height + "cm (" + gettext('height') + ") "
						         + oeuvre.with.oeuvre.width + "cm (" + gettext('width') + ")";
						if (oeuvre.with.oeuvre.depth) {
							str += oeuvre.with.oeuvre.depth + "cm (" + gettext('depth') + ")";
						}
						return [ gettext('Oeuvre size'), str ];
					case "client_oeuvre_description":
						return [ gettext("Client's description of the oeuvre"), oeuvre.description ];
					case "oeuvre_description":
						return [ gettext("Description of the oeuvre"), oeuvre.with.oeuvre.description ];
					case "oeuvre_prices":
						var prices = {}, prices_str = "";
						for (var i in oeuvre.prices) {
							var curr = oeuvre.prices[i][6];
							if (curr == "EUR") curr = "€";
							(prices[ oeuvre.prices[i][0] ] = prices[ oeuvre.prices[i][0] ] || []).push( oeuvre.prices[i][1] + " " + curr );
						}
						if (prices.sales_price) {
							prices_str += gettext( "oeuvre price sales_price" ) + ": " + prices.sales_price.join( "; " ) + "\n";
						}
						if (prices.rental_price) {
							prices_str += gettext( "oeuvre price rental_price" ) + ": " + prices.rental_price.join( "; " ) + "\n";
						}
						if (prices_str.trim()) return [ "", prices_str ];
						break;
					case "oeuvre_sales_prices":
						var prices = {}, prices_str = "";
						for (var i in oeuvre.prices) {
							var curr = oeuvre.prices[i][6];
							if (curr == "EUR") curr = "€";
							(prices[ oeuvre.prices[i][0] ] = prices[ oeuvre.prices[i][0] ] || []).push( oeuvre.prices[i][1] + " " + curr );
						}
						if (prices.sales_price) {
							prices_str += prices.sales_price.join( "; " );
						}
						if (prices_str.trim()) return [ gettext( "oeuvre price sales_price" ), prices_str ];
						break;
				}
			} catch( e ) {
				console.warn( e );
			}
		}
	}).catch(function( error ){
		console.error( error );
		$rootScope.errors.push( error );
		throw error;
	}).finally(function(){
		document.body.style.display = '';
	});
}]);
